import { ModelFactory } from "../../ModelFactory";
import { parseItemPermissions, PermissionMap } from "./PermissionMap";

export type ContactRole = { id: string; name: string; displayName: string };
export type ContactType =
  | "primary"
  | "financial"
  | "technical"
  | "security"
  | "internal";
export class Contact {
  constructor(
    public readonly id: string,
    public readonly customerId: string,
    public readonly type: ContactType,
    public readonly firstName: string,
    public readonly lastName: string,
    public readonly email: string,
    public readonly phone: string | null,
    public readonly handle: string | null,
    public readonly hasUser: boolean,
    public readonly role: ContactRole | null,
    public readonly sharesUserWithOtherCustomers: boolean,
    public readonly permissions: PermissionMap | null,
  ) {}
}

class ContactFactory extends ModelFactory<Contact> {
  protected fromJson(json: any): Contact {
    return new Contact(
      json["id"],
      json["customer_id"],
      json["type"],
      json["first_name"],
      json["last_name"],
      json["email"],
      json["phone"],
      json["handle"],
      json["has_user"],
      json["role"]
        ? {
            id: json["role"]["id"],
            name: json["role"]["name"],
            displayName: json["role"]["display_name"],
          }
        : null,
      json["shares_user_with_other_customers"] ?? false,
      parseItemPermissions(json["permissions"]),
    );
  }
}
export const contactFactory = new ContactFactory();
